const convertToDigits = (val = '') =>
  (val || '').toString().replace(/\D/g, '') || '';

export default convertToDigits;
